<div class="row">
    <div class="col-md-12 col-sm-12">
        <div class="product-details-box">

            <table *ngIf="attrs != null" class="table table-sm table-borderless"  style="max-width: 440px;">
                <tr *ngFor="let at of attrs">
                    <td  style="font-weight: bold;" width="150">{{at.lang_label}}</td>
                    <td class="{{at.attribute}}">{{at.value}}</td>
                </tr>

            </table>

            <div *ngIf="attrs == null" width="100%">
                <table style="width: 100%;">
                    <tr>
                        <td width="250"><div class="shimmer  record "></div></td>
                        <td><div class="shimmer container record "></div></td>

                    </tr>

                    <tr>
                        <td  width="250"><div class="shimmer  record "></div></td>
                        <td><div class="shimmer container record "></div></td>

                    </tr>

                    <tr>
                        <td  width="250"><div class="shimmer  record " ></div></td>
                        <td><div class="shimmer container record "></div></td>

                    </tr>  <tr>
                        <td  width="250"><div class="shimmer  record " ></div></td>
                        <td><div class="shimmer container record "></div></td>

                    </tr>  <tr>
                        <td  width="250"><div class="shimmer  record " ></div></td>
                        <td><div class="shimmer container record "></div></td>

                    </tr>  <tr>
                        <td  width="250"><div class="shimmer  record " ></div></td>
                        <td><div class="shimmer container record "></div></td>

                    </tr>

                </table>


            </div>
        </div>
    </div>
</div>